export const RECORD_SECURITY_WORDS = {
	NoAccess: 0,
	SearchOnly: 1,
	ReadOnly: 3,
	Edit: 7,
	EditDelete: 15,
	EditDeleteSecurity: 263,
	FullAccess: 271
};